import { PLAYER } from "../../../common/constants.ts";
import { isSport } from "../../../common/sportFunctions.ts";
import { idb } from "../../db/index.ts";
import { minContractExp } from "./setContract.ts";
import { g } from "../../util/index.ts";
import { MAX_MINORS_ONLY_AGE } from "../team/rosterComposition.baseball.ts";

// Up to 18 a player belongs in the minors. Every way onto a club (signing, draft, trade, and
// this daily pass for older saves) goes through here, so the rule can't be sidestepped.
export const placeYoungInMinors = (p: {
	tid: number;
	minorTid?: number;
	born: { year: number };
}) => {
	if (
		isSport("baseball") &&
		p.tid >= 0 &&
		g.get("season") - p.born.year <= MAX_MINORS_ONLY_AGE
	) {
		p.minorTid = p.tid;
		p.tid = PLAYER.MINORS;
		return true;
	}
	return false;
};

// Existing contracts of players under 21 that end before the season they turn 21 are
// extended to it at the same salary. Longer contracts are left alone. Idempotent, so it is
// safe to run on every roster check and it fixes saves made before the rule existed.
const enforceYouthContracts = async () => {
	if (!isSport("baseball")) {
		return;
	}
	const players = await idb.cache.players.indexGetAll("playersByTid", [
		PLAYER.MINORS,
		Infinity,
	]);
	for (const p of players) {
		// Free agents and undrafted players have asking prices, not contracts
		if (p.tid < 0 && p.tid !== PLAYER.MINORS) {
			continue;
		}
		if (placeYoungInMinors(p)) {
			await idb.cache.players.put(p);
		}
		const minExp = minContractExp(p);
		if (p.contract.exp >= minExp) {
			continue;
		}
		const lastPaid = Math.max(
			p.contract.exp,
			...p.salaries.map((row) => row.season),
		);
		for (let season = lastPaid + 1; season <= minExp; season++) {
			p.salaries.push({ season, amount: p.contract.amount });
		}
		p.contract.exp = minExp;
		await idb.cache.players.put(p);
	}
};

export default enforceYouthContracts;
